import { createSlice } from '@reduxjs/toolkit';
import { InvoiceNoticeLog } from '../../utils/interfaces/invoiceNoticeLogInterfaces';
import { getSupplierInvoiceNoticeLogsExtraReducer } from '../reducers/invoiceNoticeLogReducers';

export interface InvoiceNoticeLogInitialState {
  loadingList: string[];
  error: string | null;
  invoiceNoticeLogs: InvoiceNoticeLog[];
}

const initialState: InvoiceNoticeLogInitialState = {
  loadingList: [],
  error: null,
  invoiceNoticeLogs: [],
};

export const invoiceNoticeLogSlice = createSlice({
  name: 'invoiceNoticeLogs',
  initialState,
  reducers: {
    resetInvoiceNoticeLogState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierInvoiceNoticeLogsExtraReducer(builder);
  },
});

export const { resetInvoiceNoticeLogState } = invoiceNoticeLogSlice.actions;
